<template>
  <div>
    <!-- Radar -->
    <div class="mdc-layout-grid demo-grid section-privacy-security">
      <h3
        id="feature10"
        class="feature mdc-typography--headline3 text-color mb-3"
      >
        Surfverse Radar
      </h3>
      <p data-scroll class="mdc-typography--body text-color font-weight-bold">
        Este locul ideal pentru pasionații și fondatorii de produse. Stai la
        curent cu cele mai recente aplicații mobile, site-uri web, proiecte
        hardware și creații tehnologice.
      </p>
      <div class="mdc-layout-grid__inner">
        <!-- ROW 1-->
        <div
          data-aos="slide-left"
          data-aos-duration="1000"
          data-aos-delay="500"
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5 always-white">
            <h6
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="1000"
              class="mdc-typography--headline6 text-color position-relative z-3"
            >
              Misiunea Radarului nostru
            </h6>
            <p
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="1500"
              class="mdc-typography--headline5 text-color font-weight-bold position-relative z-3"
            >
              Este de a detecta zilnic cele mai bune produse noi.
            </p>
            <figure
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="500"
              class="image-feature10-item1"
              role="img-full"
            ></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          data-aos="zoom-out"
          data-aos-duration="1000"
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone z-3"
        >
          <!-- CARD CONTENT -->
          <div
            class="card-content pane-content pane-content-end p-5 always-white"
          >
            <h6
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="2500"
              class="mdc-typography--headline6 text-color position-relative z-3"
            >
              Lansează-ți produsul
            </h6>
            <p
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="3000"
              class="mdc-typography--headline5 text-color font-weight-bold position-relative z-3"
            >
              Arată lumii produsul tău și capătă fani sau chiar investitori.
            </p>
            <figure
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="2000"
              class="image-feature10-item3"
              role="img-full"
            ></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          data-aos="slide-right"
          data-aos-duration="1000"
          data-aos-delay="500"
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5 always-white">
            <h6
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="4500"
              class="mdc-typography--headline6 text-color position-relative z-3"
            >
              Votează
            </h6>
            <p
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="5000"
              class="mdc-typography--headline5 text-color position-relative font-weight-bold z-3"
            >
              Contribuie la ascensiunea produselor.
            </p>
            <figure
              data-aos="fade"
              data-aos-duration="1000"
              data-aos-delay="4000"
              class="image-feature10-item2"
              role="img-full"
            ></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>

        <!-- END ROW 1 -->
        <!-- ROW 2-->
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-8-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Confidențialitate și securitate
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              Oferim utilizatorilor controlul asupra a ceea ce și când au acces
              Atunci când utilizatorii conectează unul dintre produsele sau
              serviciile dvs. cu Google Photos, noi întotdeauna vă cerem
              permisiunea. Vă puteți deconecta integrarea în orice moment.
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <div
          class="mdc-layout-grid__cell grid-cell mdc-layout-grid__cell--span-4-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <!-- CARD CONTENT -->
          <div class="card-content pane-content p-5">
            <h6 class="mdc-typography--headline6 text-color">
              Construit pentru antreprenori, iubit de investitori.
            </h6>
            <p class="mdc-typography--headline5 text-color font-weight-bold">
              "Ceea ce urmează să facem, după ce am învățat, învățăm să facem
              numai făcând." - Aristotel
            </p>
            <figure class="image-feature1-item1" role="img"></figure>
          </div>
          <!-- END CARD CONTENT -->
        </div>
        <!-- END ROW 2 -->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  Radar: 'Radar'
}
</script>

<style>
.pane-content-end {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.z-3 {
  z-index: 3;
}
.image-feature10-item1 {
  background-image: url(/img/radar/radar.jpg);
}
.image-feature10-item2 {
  background-image: url(/img/radar/upvote.jpg);
}
.image-feature10-item3 {
  background-image: url(/img/radar/fans.jpg);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
</style>
